import { render, staticRenderFns } from "./MembersTransferPreview.vue?vue&type=template&id=207038e0"
import script from "./MembersTransferPreview.vue?vue&type=script&lang=js"
export * from "./MembersTransferPreview.vue?vue&type=script&lang=js"
import style0 from "./MembersTransferPreview.vue?vue&type=style&index=0&id=207038e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports